<template>
  <div v-if="isConnect">
    <div v-if="!isEE">
      <v-divider class="my-4"></v-divider>
      <ValidationObserver ref="observer" v-slot="{ invalid, dirty }">
        <v-row>
          <v-col cols="12" md="7" lg="5" class="py-0">
            <span class="custom-title">UNID Specification</span>
          </v-col>
        </v-row>
      </ValidationObserver>
      <v-divider class="my-4"></v-divider>
      <ValidationObserver ref="observer" v-slot="{ invalid, dirty }">
        <v-row>
          <v-col cols="12" :md="'6'" class="pt-0 pb-1" v-if="!isNCAS">
            <ValidationProvider
              name="Port Id"
              :rules="'required'"
              v-slot="{ errors }"
            >
              <v-select
                ref="portID"
                :items="getPortOptions"
                label="Port Id"
                outlined
                placeholder=" "
                :clearable="!isOriginal"
                v-model="nbnOrder.portId"
                :error-messages="errors"
                dense
                :readonly="isOriginal"
                @change="emitData()"
              ></v-select>
            </ValidationProvider>
          </v-col>

          <v-col
            cols="12"
            :md="'6'"
            class="pt-0 pb-1"
            v-if="isTransfer && (featureFlags.sog6522 ? !isHFC && !isFibre : !(isNCAS || isHFC)) && !isNCAS"
          >
            <ValidationProvider
              name="From Port Id"
              :rules="'required'"
              v-slot="{ errors }"
            >
              <v-select
                ref="fromPortIds"
                :items="fromPortIds"
                label="From Port Id"
                outlined
                placeholder=" "
                :clearable="!isOriginal"
                v-model="nbnOrder.fromPortId"
                :error-messages="errors"
                dense
                :readonly="isOriginal"
                @change="emitData()"
              ></v-select>
            </ValidationProvider>
          </v-col>

          <v-col
            cols="12"
            :md="'6'"
            class="pt-0 pb-0"
            v-if="isOriginal && !isLayer3"
          >
            <ValidationProvider
              name="cTag"
              v-slot="{ errors }"
            >
              <v-text-field
                label="C-Tag"
                name="cTag"
                outlined
                v-model="nbnOrder.cTag"
                dense
                :readonly="isOriginal"
                disabled
              ></v-text-field>
            </ValidationProvider>
          </v-col>

          <v-col
            cols="12"
            :md="'6'"
            class="pt-0 pb-0"
            v-if="isOriginal && !isLayer3"
          >
            <ValidationProvider
              name="sTag"
              v-slot="{ errors }"
            >
              <v-text-field
                label="S-Tag"
                name="sTag"
                outlined
                v-model="nbnOrder.sTag"
                dense
                :readonly="isOriginal"
                disabled
              ></v-text-field>
            </ValidationProvider>
          </v-col>
        </v-row>
      </ValidationObserver>
    </div>

    <div v-if="isEE">
      <v-divider class="mt-6 mb-4"></v-divider>
      <ValidationObserver ref="observer" v-slot="{ invalid, dirty }">
        <v-row>
          <v-col cols="12" md="7" lg="5" class="py-0 pt-5">
            <span class="custom-title">BTD Specification</span>
          </v-col>
        </v-row>
      </ValidationObserver>
      <v-divider class="mt-6 mb-4"></v-divider>
      <ValidationObserver ref="observer" v-slot="{ invalid, dirty }">
        <v-row>
          <v-col cols="12" :md="'6'" class="pt-0 pb-1">
            <ValidationProvider
              name="Preferred BTD Mounting"
              :rules="'required'"
              v-slot="{ errors }"
            >
              <v-combobox
                ref="preferredBTDMounting"
                :items="preferredBTDMounting"
                label="Preferred BTD Mounting"
                outlined
                placeholder=" "
                :clearable="!isOriginal"
                v-model="nbnOrder.preferredBTDMounting"
                :error-messages="errors"
                dense
                :readonly="isOriginal"
                @change="emitData()"
              ></v-combobox>
            </ValidationProvider>
          </v-col>
          <v-col cols="12" :md="'6'" class="pt-0 pb-1">
            <ValidationProvider
              name="Preferred Power Supply 1"
              :rules="'required'"
              v-slot="{ errors }"
            >
              <v-combobox
                ref="preferredPowerSupply1"
                :items="preferredPowerSupply1"
                label="Preferred Power Supply 1"
                outlined
                placeholder=" "
                :clearable="!isOriginal"
                v-model="nbnOrder.preferredPowerSupply1"
                :error-messages="errors"
                dense
                :readonly="isOriginal"
                @change="emitData()"
              ></v-combobox>
            </ValidationProvider>
          </v-col>
        </v-row>
      </ValidationObserver>

      <v-divider class="mt-6 mb-4"></v-divider>
      <ValidationObserver ref="observer" v-slot="{ invalid, dirty }">
        <v-row>
          <v-col cols="12" md="7" lg="5" class="py-0 pt-5">
            <span class="custom-title">UNI-E Specification</span>
          </v-col>
        </v-row>
      </ValidationObserver>
      <v-divider class="mt-6 mb-4"></v-divider>
      <ValidationObserver ref="observer" v-slot="{ invalid, dirty }">
        <v-row>
          <v-col cols="12" :md="'6'" class="pt-0 pb-1">
            <ValidationProvider
              name="Interface Bandwidth"
              :rules="'required'"
              v-slot="{ errors }"
            >
              <v-combobox
                ref="interfaceBandwidth"
                :items="interfaceBandwidth"
                label="Interface Bandwidth"
                outlined
                placeholder=" "
                :clearable="!isOriginal"
                v-model="nbnOrder.interfaceBandwidth"
                :error-messages="errors"
                dense
                :readonly="isOriginal"
                @change="emitData()"
              ></v-combobox>
            </ValidationProvider>
          </v-col>
          <v-col cols="12" :md="'6'" class="pt-0 pb-1">
            <ValidationProvider
              name="Interface Type"
              :rules="'required'"
              v-slot="{ errors }"
            >
              <v-combobox
                ref="interfaceType"
                :items="interfaceType"
                label="Interface Type"
                outlined
                placeholder=" "
                :clearable="!isOriginal"
                v-model="nbnOrder.interfaceType"
                :error-messages="errors"
                dense
                :readonly="isOriginal"
                @change="emitData()"
              ></v-combobox>
            </ValidationProvider>
          </v-col>
          <v-col cols="12" :md="'6'" class="pt-0 pb-1">
            <ValidationProvider
              name="Ovc Type"
              :rules="'required'"
              v-slot="{ errors }"
            >
              <v-combobox
                ref="ovcType"
                :items="ovcType"
                label="Ovc Type"
                outlined
                placeholder=" "
                :clearable="!isOriginal"
                v-model="nbnOrder.ovcType"
                :error-messages="errors"
                dense
                :readonly="isOriginal"
                @change="emitData()"
              ></v-combobox>
            </ValidationProvider>
          </v-col>
          <v-col cols="12" :md="'6'" class="pt-0 pb-1">
            <ValidationProvider
              name="TP ID"
              :rules="'required'"
              v-slot="{ errors }"
            >
              <v-combobox
                ref="tpid"
                :items="tpid"
                label="TP ID"
                outlined
                placeholder=" "
                :clearable="!isOriginal"
                v-model="nbnOrder.tpid"
                :error-messages="errors"
                dense
                :readonly="isOriginal"
                @change="emitData()"
              ></v-combobox>
            </ValidationProvider>
          </v-col>
        </v-row>
      </ValidationObserver>
    </div>
  </div>
</template>

<script>
export default {
  name: "nbn-realized-resource",
  props: {
    productType: { type: String },
    isConnect: { type: Boolean },
    hasNtdId: { type: Boolean },
    isTransfer: { type: Boolean },
  },
  data: () => ({
    interfaceBandwidth: [
      { text: "1 Gbps", value: "1 Gbps", disabled: false },
      { text: "10 Gbps", value: "10 Gbps", disabled: false },
    ],
    fromPortIds: [
      { text: "1", value: "1", disabled: false },
      { text: "2", value: "2", disabled: false },
      { text: "3", value: "3", disabled: false },
      { text: "4", value: "4", disabled: false },
    ],
    portIds: [
      { text: "Allocated by NBN", value: "0", disabled: false },
      { text: "1", value: "1", disabled: false },
      { text: "2", value: "2", disabled: false },
      { text: "3", value: "3", disabled: false },
      { text: "4", value: "4", disabled: false },
    ],
    interfaceType: [
      {
        text: "Copper (Auto-negotiate)",
        value: "Copper (Auto-negotiate)",
        disabled: false,
      },
      {
        text: "Optical (Single mode)",
        value: "Optical (Single mode)",
        disabled: false,
      },
      {
        text: "Optical (Multi mode)",
        value: "Optical (Multi mode)",
        disabled: false,
      },
    ],
    ovcType: [
      { text: "Access EPL", value: "Access EPL", disabled: false },
      { text: "Access EVPL", value: "Access EVPL", disabled: false },
    ],
    tpid: [
      { text: "0x8100", value: "0x8100", disabled: false },
      { text: "0x88a8", value: "0x88a8", disabled: false },
      { text: "0x9100", value: "0x9100", disabled: false },
    ],
    preferredBTDMounting: [
      { text: "Rack", value: "Rack", disabled: false },
      { text: "Wall", value: "Wall", disabled: false },
    ],
    buildingHeight: [
      { text: "Single Storey", value: "Single Storey", disabled: false },
      {
        text: "2 or more storeys",
        value: "2 or more storeys",
        disabled: false,
      },
    ],
    roofType: [
      { text: "Tin", value: "Tin", disabled: false },
      { text: "Fibro Cement", value: "Fibro Cement", disabled: false },
      { text: "Asbestos", value: "Asbestos", disabled: false },
      { text: "Tile", value: "Tile", disabled: false },
      { text: "Other", value: "Other", disabled: false },
    ],
    powerSource: [
      { text: "AC", value: "AC", disabled: false },
      { text: "DC", value: "DC", disabled: false },
    ],
    wallMaterial: [
      { text: "Double Brick", value: "Double Brick", disabled: false },
      {
        text: "Single Brick with Cladding",
        value: "Single Brick with Cladding",
        disabled: false,
      },
      {
        text: "Cladding (Timber, Compressed Cement)",
        value: "Cladding (Timber, Compressed Cement)",
        disabled: false,
      },
      {
        text: "Cladding (Asbestos, Fibro Cement)",
        value: "Cladding (Asbestos, Fibro Cement)",
        disabled: false,
      },
      { text: "Any", value: "Any", disabled: false },
    ],
    preferredPowerSupply1: [
      { text: "DC (-48V)", value: "DC (-48V)", disabled: false },
      { text: "AC (240V)", value: "AC (240V)", disabled: false },
    ],
  }),
  methods: {
    emitData() {
      let vm = this;
      vm.$emit("emitNbnRealizedResource", vm.nbnOrder);
    },
    resetForm() {
      let vm = this
      if(vm.isConnect){
        if(!vm.isNCAS && !vm.isEE) {
          vm.$refs.portID.reset()

          if(vm.isTransfer && !(vm.isNCAS || vm.isHFC))
            vm.$refs.fromPortIds.reset()
        }
      }
    },
  },
  computed: {
    isNCAS() {
      let vm = this;
      if (
        vm.nbnOrder.productType != null &&
        (vm.nbnOrder.productType === "FTTB" ||
          vm.nbnOrder.productType === "FTTC" ||
          vm.nbnOrder.productType === "FTTN")
      ) {
        return true;
      } else {
        return false;
      }
    },
    getPortOptions() {
      let vm = this
      if(
        (vm.nbnOrder.orderType == 'Transfer' || vm.nbnOrder.orderType == 'Connect') &&
        (vm.isFibre || vm.isFixedWireless || vm.isHFC)
      ) {
          if(vm.nbnOrder.ntdModifications === 'REPLACE SELECTED NTD' || 
            vm.nbnOrder.ntdModifications === 'REQUEST NEW NTD' 
          ) {

            if(vm.nbnOrder.ntdType === "1_PORT"){
              return [{ text: "Allocated by NBN", value: "0", disabled: false },
                    { text: "1", value: "1", disabled: false }]
            }
            else
              return [{ text: "Allocated by NBN", value: "0", disabled: false },
                    { text: "1", value: "1", disabled: false },
                    { text: "2", value: "2", disabled: false },
                    { text: "3", value: "3", disabled: false },
                    { text: "4", value: "4", disabled: false }]
          }

        if(vm.sqNbnResult?.sq?.siteRestriction !== undefined)
        {
          let selectedNtd = vm.sqNbnResult.sq.siteRestriction.supportingResource
            .filter(x => x.id == (vm.nbnOrder.ntdId == '' ? vm.ntdOptions[0] : vm.nbnOrder.ntdId))
          if(selectedNtd.length == 0) return [{ text: "Allocated by NBN", value: "0", disabled: false }]
          let filtered_ports = selectedNtd[0].uniPortD
            .filter(x => vm.nbnOrder.orderType == 'Transfer' ? x.status == "Used" : x.status == "Free")
          if(filtered_ports.length == 0) return [{ text: "Allocated by NBN", value: "0", disabled: false }]
          let ports = filtered_ports.map(x => x.id.substring(x.id.length - 1, x.id.length))
          if(vm.nbnOrder.orderType == 'Connect') ports.push('0')
          var result = vm.portIds.filter(x => ports.some(y => y == x.value));
          return result;
        }
      }
      return vm.portIds
    },
    isEE() {
      let vm = this;
      if (
        vm.nbnOrder.productType != null &&
        (vm.nbnOrder.productType === "Enterprise Ethernet")
      ) {
        return true;
      } else {
        return false;
      }
    },
    isFibre() {
      let vm = this;
      if (
        vm.nbnOrder.productType != null &&
        (vm.nbnOrder.productType === "Fibre")
      ) {
        return true;
      } else {
        return false;
      }
    },
    isHFC() {
      let vm = this;
      if (
        vm.nbnOrder.productType != null &&
        (vm.nbnOrder.productType === "HFC")
      ) {
        return true;
      } else {
        return false;
      }
    },
    isFixedWireless() {
      let vm = this;
      if (
        vm.nbnOrder.productType != null &&
        (vm.nbnOrder.productType === "Fixed Wireless")
      ) {
        return true;
      } else {
        return false;
      }
    },
    hasNtd() {
      let vm = this;
      return vm.hasNtdId;
    },
  },
};
</script>

<style scoped>
</style>
